import Button from '../atoms/Button';
import Modal from './Modal';

/**
 * ConfirmModal — standard confirm dialog (delete etc.).
 * Footer: `Batal` (secondary) + confirm button (`danger` by default, `loading`).
 * `message` may be JSX; `hint` renders as muted secondary text.
 */
export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  hint,
  confirmLabel = 'Hapus',
  cancelLabel = 'Batal',
  confirmVariant = 'danger',
  confirmIcon,
  loading = false,
  size,
  children,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} icon={confirmIcon} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {message && <p className="modal-text-desc">{message}</p>}
      {hint && <p className="modal-text-hint">{hint}</p>}
      {children}
    </Modal>
  );
}
